import React from "react";
import { createTabPane } from "@whalecloud/page-builder-core/utils/elementUtils";
import TabsElement from "./components/TabsElement";
import TabsSetting from "./components/TabsSetting";
import { ReactComponent as PluginSvg } from "@assets/icons/tabs_setting.svg";
import { getLocale, defaultTarget } from '@utils/util';

const defaultTabs = [
  { text: 'Tab 1' },
  { text: 'Tab 2' },
  { text: 'Tab 3' },
];

const getElements = () => {
  const elements = [];
  defaultTabs.forEach(item => {
    elements.push(createTabPane());
  });
  return elements;
}

export default () => {
  const messages = getLocale();
  return {
    name: 'tabs',
    target: defaultTarget,
    title: messages['PAGEBUIDER_ELEMENT_Tabs'], // 插件标题
    toolBarPreview: <PluginSvg />,
    data: {
      formItemSettings: {
        tabPosition: 'top',
        type: 'line',
        tabs: defaultTabs
      },
      formSettings: {
        label: messages['PAGEBUIDER_ELEMENT_Tabs']
      },
      settings: {
        margin: {
          mobile: { all: 0 },
          desktop: { all: 0 },
          advanced: true
        },
        padding: {
          mobile: { top: 15, left: 15, right: 15, bottom: 15 },
          desktop: { top: 0, left: 25, right: 25, bottom: 0 },
        },
        width: {
          value: "100%"
        },
      }
    },
    elements: getElements,
    pluginComponent: TabsElement,
    pluginSettingComponent: TabsSetting,
  }
}
